import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {product} from '../../api/product/product.api';
import {RequestService} from '../../../handlers/request/request.service';
import {globalEnv} from '../../connection/global/global.env';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private req: RequestService) { }

  getItem(params): Observable<any> {
    return this.req.get(`${globalEnv.be2}${product.getItem}`, params, null, true);
  }

  getItemV2(params): Observable<any> {
    return this.req.get(`${globalEnv.be2}${product.getItemV2}`, params, null, true, true, false);
  }

  getFiltersItems(params): Observable<any> {
    this.req.get(`${globalEnv.be2}${product.getFiltersItems}`, params, null, true).subscribe( res => console.log( 'Filter Items', res ) );
    return this.req.get(`${globalEnv.be2}${product.getFiltersItems}`, params, null, true);
  }

  getItemAvailable(params): Observable<any> {
    return this.req.get(`${globalEnv.be2}${product.getItemAvailable}`, params, null, true);
  }

  getDiscounts(data): Observable<any> {
    return this.req.post(`${globalEnv.gateway}${product.getDiscounts}`, data, null, true);
  }
}
